import  {  useEffect, useState } from "react";
import { client, clientPay, comment, notPay, pay } from "../../util/icon";
import { getClientInfo } from "../../util/main";
import { postReadSmsFetch } from "../../features/action/fetchSMS";
import { useDispatch } from "react-redux";


export const SmsItem = ({ isUser,item, onToggle }) => {
  const [hasNewSms, setHasNewSms] = useState(false);
  const [showClientInfo, setShowClientInfo] = useState(false);
  const { name: clientName, phone: clientPhone } = getClientInfo(item.client);
  const dispatch = useDispatch();

const handleReadSms = (e) => {
   e.stopPropagation();
   if (!item.readBy?.includes(isUser?.username)) {
     dispatch(postReadSmsFetch(isUser?.username, item.order));
   }
 };
 useEffect(() => {
   if (item?.readBy?.includes(isUser?.username)) {
     setHasNewSms(true);
   } else {
     setHasNewSms(false);
   }
 }, [item, isUser?.username]);
  return (
    <div className="flex py-0.5">
      <div className="relative flex overflow-hidden" onClick={handleReadSms}>
        <button
          className={`w-[216px] h-[60px] flex items-center justify-center rounded-l-[8px] bg-[#739D00] cursor-pointer`}
          onClick={onToggle}
          
        >
          <p className="font-rubik font-black text-[clamp(20px,3vw,40px)] leading-tight tracking-wide-5 text-[#FFFFFF] px-1">
            {item.order}
          </p>
        </button>
        {item.readBy? (
          <div className="flex w-[80px] bg-[#739D00] items-center justify-center" onClick={onToggle}>
            {comment}
          </div>
        ) : (
          <div className="flex w-[80px] bg-[#FF6D00] items-center justify-center" onClick={onToggle}>
            {comment}
          </div>
        )}
        {/* Выезжающая панель с информацией о клиенте */}
        <div
          className={`absolute inset-0 bg-[#ffffff] flex items-center justify-center transition-transform duration-500 ease-in-out z-10  rounded-l-[8px] ${
            showClientInfo ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="text-black font-rubik text-sm text-center px-2">
            <p className="font-bold leading-tight mb-1">
              {clientName}
            </p>
            <p className="text-xs leading-tight">{clientPhone}</p>
          </div>
        </div>
      </div>
      <div
        className="w-[60px] content-center cursor-pointer"
        onClick={() => setShowClientInfo(!showClientInfo)}
      >
        { client}
      </div>
      <div
        className={`w-[16px] rounded-r-[8px] ${
          item.readBy?.includes(isUser?.username)? "bg-[#739D00]" : "bg-[#FF6D00]"
        }`}
      ></div>
    </div>
  );
};